import { useEffect } from "react";

import { cookieRefresh } from "@/lib/auth-api";
import { resolveSessionUser } from "@/lib/auth-session";
import { useAuthStore } from "@/stores/auth-store";

export function SessionBootstrap() {
  const clearSession = useAuthStore((state) => state.clearSession);
  const setLoading = useAuthStore((state) => state.setLoading);
  const setSession = useAuthStore((state) => state.setSession);

  useEffect(() => {
    let cancelled = false;

    async function bootstrap() {
      setLoading(true);
      try {
        const refreshed = await cookieRefresh();
        if (cancelled) return;

        if (!refreshed) {
          clearSession();
          return;
        }

        const user = await resolveSessionUser(refreshed.access_token);
        if (cancelled) return;

        if (!user) {
          clearSession();
          return;
        }

        setSession({
          user,
          session: {
            token: refreshed.access_token,
            expiresAt: refreshed.expires_at,
          },
        });
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    }

    void bootstrap();

    return () => {
      cancelled = true;
    };
  }, [clearSession, setLoading, setSession]);

  return null;
}
